export default __webpack_public_path__ + "static/media/points.ecfc1d62.png";